import type { EventEmitter } from 'ahooks/lib/useEventEmitter';
import type { SelectData } from '../CatalogTree';
import { useRef } from 'react';
import Content from './components/Content';
import styles from './index.module.less';
import { useMemoizedFn } from 'ahooks';
import type { ManualRecord } from '@/api/sip/bookmap/list';

type SearchAllProps = {
  searchSelect$: EventEmitter<SelectData>;
  manuaList: ManualRecord[];
};

export default (props: SearchAllProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const scrollToTop = useMemoizedFn(() => {
    containerRef.current?.scrollTo(0, 0);
  });

  return (
    <div ref={containerRef} style={{ height: '100%' }}>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Content
          scrollToTop={scrollToTop}
          className={styles.content}
          searchSelect$={props.searchSelect$}
          manuaList={props.manuaList}
        />
      </div>
    </div>
  );
};
